import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin, Select } from 'antd';
import { formItemLayout, tailFormItemLayout } from '../../../common_functions';

const GeoLoc = props => {
  const { section, id } = useParams();
  const [location, setLocation] = useState({});
  const [loading, setLoading] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [parks, setParks] = useState([]);
  const formRef = useRef(null);
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const { data: stateData } = await props.getItems('states', {
          fields: ['id', 'state'],
          limit: '-1',
          sort: 'state',
        });
        setStateList(stateData);
        if (id !== 'new') {
          let { data } = await props.getItem('geographic_locations', id);
          await showParks(data.state);
          setLocation(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        Modal.warning({
          title: 'Error',
          content: 'Unexpected error occured',
        });
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);
  const showParks = async stateID => {
    setLoading(true);
    setParks([]);
    if (!!stateID) {
      const { data: parkData } = await props.getItems('parks', {
        fields: ['id', 'park'],
        limit: '-1',
        sort: 'park',
        filters: { state: { _eq: stateID } },
      });
      setParks(parkData);
    }
    setLoading(false);
  };
  let onFinish = values => {
    setLoading(true);
    let newState = { ...location, ...values };
    props
      .saveItem('geographic_locations', newState)
      .then(
        response => {
          setLoading(false);
          if (response) {
            notification['success']({
              message: 'Geographic location saved successfully!',
              duration: 2,
            });
            setTimeout(() => props.history.push('/settings/geographic-locations', 1500));
          }
        },
        errorReponse => {
          if (errorReponse.errors !== undefined) {
            for (var i = 0; i < errorReponse.errors.length; i++) {
              var errorObj = errorReponse.errors[i];
              var errorField = errorObj.extensions.field;
              var errorFieldMessage = errorObj.message;
              formRef.current.setFields([
                {
                  name: errorField,
                  errors: [errorFieldMessage],
                },
              ]);
            }
          } else {
            Modal.warning({
              title: 'Error',
              content: 'Unexpected error occured',
            });
          }
        }
      )
      .catch(error => {
        setLoading(false);
        Modal.warning({
          title: 'Error',
          content: 'Not Saved!',
        });
      });
    setLoading(false);
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };
  let backButton = () => {
    setTimeout(() => props.history.push('/settings/geographic-locations', 1500));
  };
  return (
    <>
      <Spin spinning={loading} size="large">
        <Row>
          <Col className="app-breadcrumb-col">
            <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/geographic-locations" }, { title: "Geographic Locations", href: "/settings/geographic-locations" }, { title: id != 'new' ? `Edit Geographic Location` : 'Add Geographic Location' }]} />
          </Col>
          <Col className="white-paper">
            <Row gutter={24} className="page-header-section" align="middle">
              <Col xs={12}>
                <Typography.Title level={4} style={{ margin: 0 }}>
                  {id != 'new' ? `Edit  Geographic Location: ${id}` : 'Add  Geographic Location'}
                </Typography.Title>
              </Col>
              <Col xs={12} justify="end"></Col>
            </Row>
            <hr />
            <div className="artist">
              <Form
                ref={formRef}
                layout="vertical"
                {...formItemLayout}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={{ layout: tailFormItemLayout }}
              >
                <Row gutter={24}>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="state"
                      label="State"
                      rules={[
                        {
                          required: true,
                          message: 'State is required!',
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select State"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        style={{ textTransform: 'capitalize' }}
                        onChange={showParks}
                      >
                        {stateList.map(item => {
                          return (
                            <Option key={item.id} value={item.id} style={{ textTransform: 'capitalize' }}>
                              {item.state}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="park"
                      label="Park/Monument/Wilderness/etc"
                      rules={[
                        {
                          required: true,
                          message: 'Park/Monument/Wilderness/etc is required!',
                        },
                      ]}
                    >
                      <Select
                        placeholder="Select Park"
                        showSearch
                        allowClear
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                        style={{ textTransform: 'capitalize' }}
                      >
                        {parks.map(item => {
                          return (
                            <Option key={item.id} value={item.id} style={{ textTransform: 'capitalize' }}>
                              {item.park}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="tgn_id_1" label="TGN ID 1">
                      <Input placeholder="Enter TGN ID 1" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="tgn_id_2" label="TGN ID 2">
                      <Input placeholder="Enter TGN ID 2" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="prominent_natural_features"
                      label="Prominent Natural Features"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Prominent Natural Features is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter prominent natural features" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="cona_id" label="Cona ID">
                      <Input placeholder="Enter Cona ID" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="latitude"
                      label="Latitude"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Latitude is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter latitude" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item
                      name="longitude"
                      label="Longitude"
                      rules={[
                        {
                          whitespace: true,
                          required: true,
                          message: 'Longitude is required!',
                        },
                      ]}
                    >
                      <Input placeholder="Enter Longitude" />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item {...tailFormItemLayout}>
                  <Button
                    type="default"
                    htmlType="button"
                    onClick={backButton}
                    style={{
                      borderColor: '#d9d9d9',
                      background: '#f5f5f5',
                      color: 'rgba(0, 0, 0, 0.85)',
                    }}
                  >
                    Back
                  </Button>
                  {props.showButton(props.roleType, props.tabs_permissions.settings_geographic_locations, !!location ? location.id : '')}
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default GeoLoc;
